import type {TextProps} from '@smart/react-components';
import {
  Markdown,
  Text,
  defaultMarkdownOverrides,
} from '@smart/react-components';
import * as React from 'react';
import {MarkdownLink} from './markdown-link';

export interface PaymentDetailsProps {
  readonly text: string;
}

const headingOverride = {
  ...defaultMarkdownOverrides.h1,
  props: {
    ...defaultMarkdownOverrides.h1.props,
    margin: {bottom: 200},
    variant: `lbl-100`,
    color: `c-mid-contrast`,
  } satisfies TextProps,
};

const paragraphOverride = {
  ...defaultMarkdownOverrides.p,
  props: {
    ...defaultMarkdownOverrides.p.props,
    margin: {bottom: 200},
    variant: `cap-100`,
    color: `c-mid-contrast`,
  } satisfies TextProps,
};

const anchorOverride = {
  component: MarkdownLink,
};

export const PaymentDetails = React.memo(({text}: PaymentDetailsProps) => (
  <Text color="c-mid-contrast" asChild>
    <Markdown
      overrides={{
        h1: headingOverride,
        h2: headingOverride,
        h3: headingOverride,
        h4: headingOverride,
        h5: headingOverride,
        h6: headingOverride,
        p: paragraphOverride,
        a: anchorOverride,
      }}
    >
      {text}
    </Markdown>
  </Text>
));
